const isDebuggerProduction = true; // 本地调试线上环境

module.exports = {
  isDebuggerProduction
};
